import React from "react";
import { EnumWrapper } from "../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../utils/enums/enums";
import BrokersDataTable from "./BrokersDataTable";

const BrokersPage = () => {
  return (
    <div className="sub-content">
      <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
        <BrokersDataTable />
      </EnumWrapper>
    </div>
  );
};

export default BrokersPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/BrokersPage.js